<template>
    <div data-component="AmsPriceIndicatorModal">
        <cs-modal v-model:visible="visible" headerText="Preisbewertung">
            <ms-headline type="h3">Preisbewertung für dein Fahrzeug</ms-headline>

            <div class="flex flex-col gap-32 screen-m:gap-40">
                <ams-price-indicator-modal-tags :item="item" :hasRating="hasRating" />
                <ams-price-scale
                    v-if="hasRating"
                    :priceClass="item.priceIndicator.priceClass"
                    :price="item.price"
                    :priceIndicatorClasses="priceIndicatorClasses"
                />

                <ams-price-indicator-modal-recommendation :priceClass="item.priceIndicator.priceClass" />
                <ams-price-indicator-modal-comparison-criteria :item="item" :hasRating="hasRating" />
                <ams-price-indicator-modal-info v-if="hasRating" />
            </div>
        </cs-modal>
    </div>
</template>

<script lang="ts" setup>
import { CsModal } from '@sunrise/components'
import { PropType, computed } from 'vue'
import { MsHeadline } from '@sunrise/components'
import { AmsItem, PriceClass } from '../../../services/amsSearch/amsSearch.interface'
import AmsPriceScale from '../AmsPriceScale/AmsPriceScale.vue'
import AmsPriceIndicatorModalTags from './AmsPriceIndicatorModalTags.vue'
import AmsPriceIndicatorModalComparisonCriteria from './AmsPriceIndicatorModalComparisonCriteria.vue'
import AmsPriceIndicatorModalRecommendation from './AmsPriceIndicatorModalRecommendation.vue'
import AmsPriceIndicatorModalInfo from './AmsPriceIndicatorModalInfo.vue'

const props = defineProps({
    visible: {
        type: Boolean,
        required: true,
    },
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
})

const emit = defineEmits<{
    (e: 'update:visible', event: boolean): void
}>()

const visible = computed({
    get() {
        return props.visible
    },
    set(newValue) {
        emit('update:visible', newValue)
    },
})

const hasRating = computed(() => props.item.priceIndicator.priceClass !== PriceClass.NotSpecified)
const priceIndicatorClasses = computed(() => [
    props.item.priceIndicator.class1,
    props.item.priceIndicator.class2,
    props.item.priceIndicator.class3,
    props.item.priceIndicator.class4,
    props.item.priceIndicator.class5,
    props.item.priceIndicator.class6,
])
</script>
